// The four stages of a Five Lights Reno project.
//
// Built from what the business already commits to in its own copy — a
// walkthrough before quoting, a written scope and timeline before work starts,
// permits handled in-house where required, dust containment during the work,
// and a walkthrough at the end. Nothing here promises a response time, a
// warranty term or a fixed price, because none of those have been confirmed.

export const PROCESS = [
  {
    number: "01",
    title: "Discover",
    lead: "We walk the space with you.",
    body: "Before any numbers, we come out and look. What you want to change, what's annoyed you for years, how the room actually gets used day to day — and what the building will and won't allow. You get an honest read on scope, including the parts that aren't worth doing.",
    photo: "basementBedroom",
  },
  {
    number: "02",
    title: "Plan",
    lead: "Scope, materials and timeline, in writing.",
    body: "You get a written scope and a real timeline before anything is committed — not a range that shifts once the work starts. Where a project needs permits, drawings or inspections, we handle the application and the scheduling rather than handing you a list of phone calls.",
    photo: "insulationFraming",
  },
  {
    number: "03",
    title: "Build",
    lead: "One crew, containment up, site kept clean.",
    body: "Sheeting and dust containment go up before the first tool comes out, and stay up. Because we self-perform most trades, there's one crew in your home and one person accountable for it. You'll know what's happening each week without having to chase anyone for an update.",
    photo: "staircaseInProgress",
  },
  {
    number: "04",
    title: "Complete",
    lead: "Walkthrough, punch list, and the site left clean.",
    body: "We walk the finished work with you and write down anything that isn't right, then fix it — before the job is called done rather than after. You're left with a clean space, the care instructions for what we installed, and a number that still answers.",
    photo: "staircaseAfter",
  },
];

// Why-us differentiators. Each one is a claim the business can actually stand
// behind: self-performed trades, permit handling, containment, and one point
// of contact are all evidenced in the project photography and existing copy.
export const DIFFERENTIATORS = [
  {
    title: "One crew, not a chain of subcontractors",
    body: "We self-perform most of the trades on a project — framing, drywall, tile, flooring, paint. That's why the trim lines up and the transitions land where they should, and why there's one person to call when you have a question.",
  },
  {
    title: "Permits handled, not handed to you",
    body: "Where a project needs a building permit or an inspection, we make the application and coordinate the schedule. On legal basement work in particular, that's most of what separates a finished basement from a legal one.",
  },
  {
    title: "The work behind the finish gets the attention",
    body: "Waterproofing before tile, levelled subfloor before plank, vapour barrier detailed properly below grade. None of it shows in a photo — all of it decides whether the room is still sound in fifteen years.",
  },
  {
    title: "Your house stays livable",
    body: "Containment goes up before demolition and stays up. Job sites get tidied at the end of the day. Most of our clients are living in the house while we work, and the project is planned around that.",
  },
];

// Shown in place of testimonials while no verified reviews exist. Labelled in
// the UI as commitments, never as customer feedback.
export const COMMITMENTS = [
  {
    title: "Clear communication",
    body: "You'll know where your project stands without chasing us for an update.",
  },
  {
    title: "Transparent pricing",
    body: "A written scope, and no costs that appear for the first time halfway through.",
  },
  {
    title: "Respect for your home",
    body: "Containment up, floors protected, and the site tidied at the end of each day.",
  },
  {
    title: "Reliable scheduling",
    body: "We show up when we said we would, and tell you early if anything moves.",
  },
];
